/**
 * @generated SignedSource<<669c4e8aed1e137372ae07e78b583b67>>
 * @relayHash 7ea43002279108ebdaf4bacd5136e32c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyBlogDeleteMutation$variables = {
  blogPostId: string;
  propertyKey: string;
};
export type useUpdateContentPropertyBlogDeleteMutation$data = {
  readonly confluence: {
    readonly deleteBlogPostProperty: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyBlogDeleteMutation = {
  response: useUpdateContentPropertyBlogDeleteMutation$data;
  variables: useUpdateContentPropertyBlogDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "blogPostId",
        "variableName": "blogPostId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "propertyKey"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyBlogDeleteMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "deleteBlogPostProperty",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyBlogDeleteMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "deleteBlogPostProperty",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7ea43002279108ebdaf4bacd5136e32c",
    "id": "b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf",
    "metadata": {},
    "name": "useUpdateContentPropertyBlogDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyBlogDeleteMutation($propertyKey:String!,$blogPostId:ID!){confluence{deleteBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
  }
};
})();

(node as any).hash = "9c55ced69dfdca7b034578bc15733a6a";

export default node;
